import { render, staticRenderFns } from "./ot-aconex-mail-list.vue?vue&type=template&id=342f385e&scoped=true&"
import script from "./ot-aconex-mail-list.vue?vue&type=script&lang=ts&"
export * from "./ot-aconex-mail-list.vue?vue&type=script&lang=ts&"
import style0 from "./ot-aconex-mail-list.vue?vue&type=style&index=0&id=342f385e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342f385e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
